var rules = require('./data/rules')
var webviewRegExp = new RegExp('(' + rules.join('|') + ')', 'ig')

module.exports = function isWebview(ua) {
  return !!ua.match(webviewRegExp)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-ua-webview/index.js
// module id = 646
// module chunks = 2